import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";



export default function Pendencias({
  pendenciaCompany
}: {
  pendenciaCompany: any
}) {
  const { t } = useTranslation();

  
  if(pendenciaCompany.spc && pendenciaCompany.spc.spc){
    pendenciaCompany = pendenciaCompany.spc;
  }
  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string; }) => any; }) => {
    return value.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });
  }

  const avalista = (item:any) => {
    return item.avalista ? 'Sim' : 'Não';
  };

  const valor = (item:any) => {
    return formatarParaMoedaBRL(item.valorPendencia);
  };

  const valorSPC = (item:any) => {
    return formatarParaMoedaBRL(item.valor);
  };
  

  const dataInclusao = (item:any) => {
    return formatDate(new Date(item.dataInclusao));
  };

  const dataVencimento = (item:any) => {
    return formatDate(new Date(item.dataVencimento));
  };

  const dataRegistro = (item:any) => {
    return formatDate(new Date(item.dataOcorrencia));
  };

  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {pendenciaCompany.pendenciaFinanceira && pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 ?  (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('pendencias')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('pendencias')}</span>) }</div>;
  }

  const headerTemplateNegativacao = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> { pendenciaCompany.spc && pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 ?  (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('negativacoes')}</span></span>):(<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('negativacoes')}</span>)}</div>;
  }
  
  return (
    <>
     
      <Panel headerTemplate={headerTemplate}>
         {pendenciaCompany.pendenciaFinanceira && pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 ? (
          <DataTable size="small" value={pendenciaCompany.pendenciaFinanceira.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
            <Column body={dataRegistro} header={t('dataRegistro')}></Column>
            <Column body={avalista} header={t('avalista')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column body={valor} header={t('valor')}></Column>
            <Column field="origem" header={t('empresa')}></Column>
            <Column field="tituloOcorrencia" header={t('natureza')}></Column>
            <Column field="cidade.nome" header={t('cidade')}></Column>
            <Column field="cidade.estado.siglaUf" header={t('uf')}></Column>
          </DataTable>
         ):(<NadaConsta></NadaConsta>)}
      </Panel>

      
 
      <br></br>
      <Panel headerTemplate={headerTemplateNegativacao}>
        {pendenciaCompany.spc && pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista && pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista.length > 0 ? (
          <DataTable size="small" value={pendenciaCompany.spc.detalheGrafiaPjOrDetalheSpcOrDetalheChequeLojista} tableStyle={{ minWidth: '50rem' }}>
            <Column body={dataInclusao} header={t('dataRegistro')}></Column>
            <Column body={dataVencimento} header={t('dataVencimento')}></Column>
            <Column field="compradorFiadorAvalista" header={t('tipo')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column body={valorSPC} header={t('valor')}></Column>
            <Column field="nomeAssociado" header={t('empresa')}></Column>
            <Column field="cidadeAssociado.nome" header={t('cidade')}></Column>
            <Column field="cidadeAssociado.estado.siglaUf" header={t('uf')}></Column>
          </DataTable>
        ):(<NadaConsta></NadaConsta>)}
      </Panel>


    </>
  )
}